import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';

import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { Suggestions } from '../../../shared/suggestable-input/entities/suggestions.entity';

import { MessageCollationneTLR } from '../entities/message-collationne-tlr.entity';
import { MessageCollationneDTO } from '../entities/message-collationne-dto.entity';
import { MessageCollationneCreate } from '../entities/message-collationne-create.entity';
import { MessagesCollationnesFilters } from '../entities/messages-collationnes-filters.entity';

@Injectable({ providedIn: 'root' })
export class MessageCollationneService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService, //
		@Optional() @SkipSelf() previousInstance?: MessageCollationneService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	// Methode permettant le chargement des messages collationnes
	public getMessagesByFilters(filters: MessagesCollationnesFilters): Observable<MessageCollationneDTO[]> {
		let url = this.path + 'messageCollationne';

		// Liste des parametres representant des localdate ou localdatetime
		let dateParams = ['dateMin', 'dateMax'];
		
		let parameters = new HttpParams();
		for (let key in filters) {
			let value = (filters as any)[key];
			if (value != undefined && value != null) {
				let param = value;
				if (dateParams.includes(key)) {
					let date = this.conversionService.fromMandatoryLocalDate(value);
					param = this.conversionService.toLocalDateParam(date);		
				}
				parameters = parameters.set(key, param);
			}
		}
		let result = this.httpClient //
			.get<MessageCollationneDTO[]>(url, { params: parameters }) //
		;

		return result;
	}

	// Methode permettant la sauvegarde d'un nouveau message
	public createMessage(message: MessageCollationneCreate): Observable<MessageCollationneTLR> {
		const url = this.path + 'messageCollationne';
		const request$ = this.httpClient.post<MessageCollationneTLR>(url, message, {});
		return request$;
	}
	
	// Methode permettant de recuperer le prochain id de message disponible
	public getNextId(): Observable<number> {
		const url = this.path + 'messageCollationne/nextId';
		const request$ = this.httpClient.get<number>(url);
		return request$;
	}
	
	// Methode permettant d'evaluer le numero d'un message
	public getNumero(message: MessageCollationneTLR) {
		if (!message.id) {
			return ""
		}
		
		return (message.emetteur ? "E" : "R") + message.id.toString().padStart(5, "0");
	}

	// Methode d'obtention des suggestions de parcs en construction
	public getSuggestionsParcsEnConstruction(criteria: string, quantity: number): Observable<Suggestions<number, String>> {
		let url = this.path + 'messageCollationne/suggestions_parcs_en_construction';
		let parameters = new HttpParams();
		parameters = parameters.set('criteria', criteria);
		parameters = parameters.set('limit', quantity);
		let result = this.httpClient //
			.get<Suggestions<number, String>>(url, { params: parameters }) //
		;
		return result;
	}
}